import React from 'react';

const IframeView = ({ item }) => {
  if (!item || !item.url) return null; // 👈 Changed from item.link to item.url

  return (
    <div className="w-full min-h-screen flex flex-col items-center justify-center">
      <iframe
        title={item.title}
        src={item.url}
        className="w-full h-screen border-0 rounded-xl"
        allowFullScreen
      />
    </div>
  );
};

export default IframeView;
